module.exports = __webpack_public_path__ + "static/img/8.e8e4ddf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/8.png
// module id = 3WSy
// module chunks = 0